import psl_ui from '../../libs/psl_ui.js';

import data from '../../data.js';

import state from '../../state.js';

import './style.scss';
import template from './template.pst';

psl_ui.templates.add('circles',template);

const {els,rpoints}=psl_ui.templates.render('circles');

state.events.on('era',_transition);
state.events.on('roads',_render);
state.events.on('cities',_render);
state.events.on('ama_members',_render);
state.events.on('covered_km',_render);

let _rendered_values={
	population:0,
	members:0,
	highway:0,
	covered:0,
	year:0,
};

let names = ['population','members','highway','covered'];

const _animation_handles = {};

function _format_number(number){
	return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const DURATION = 750;

function _animate_counter(key,start_value,end_value,duration=DURATION){
	if(_animation_handles[key]) cancelAnimationFrame(_animation_handles[key]);
	
	const start_time = performance.now();
	const difference = end_value - start_value;
	
	function _update(current_time){
		const elapsed = current_time - start_time;
		const progress = Math.min(elapsed / duration, 1);
		const ease_out_quad = 1 - Math.pow(1 - progress, 3);
		const current_value = Math.round(start_value + difference * ease_out_quad);
		
		rpoints[`${key}_value`].textContent = _format_number(current_value);

		_rendered_values[key] = current_value;
		
		if(progress < 1){
			_animation_handles[key] = requestAnimationFrame(_update);
		} else {
			rpoints[`${key}_value`].textContent = _format_number(end_value);
			_animation_handles[key] = null;
			_rendered_values[key] = end_value;
		}
	}
	
	_animation_handles[key] = requestAnimationFrame(_update);
}

function _animate_year(start_value,end_value,duration=DURATION){
	if(_animation_handles.year) cancelAnimationFrame(_animation_handles.year);
	
	const start_time = performance.now();
	const difference = end_value - start_value;
	
	function _update(current_time){
		const elapsed = current_time - start_time;
		const progress = Math.min(elapsed / duration, 1);
		const ease_out_quad = 1 - Math.pow(1 - progress, 3);
		const current_value = Math.round(start_value + difference * ease_out_quad);
		
		for(let i=0;i<4;i++) rpoints[`year_${i}`].textContent = `(${current_value})`;
		
		_rendered_values.year = current_value;

		if(progress < 1){
			_animation_handles.year = requestAnimationFrame(_update);
		} else {
			for(let i=0;i<4;i++) rpoints[`year_${i}`].textContent = `(${end_value})`;
			_animation_handles.year = null;
			_rendered_values.year = end_value;
		}
	}
	
	_animation_handles.year = requestAnimationFrame(_update);
}

function _transition(){
	const target_stats = data.eras[state.era].stats;

	for(let name of names) _animate_counter(name, _rendered_values[name], target_stats[name]);

	if(_format_number(target_stats.covered).length > 10){
		rpoints.covered.classList.add('small');
	} else if(rpoints.covered.classList.contains('small')){
		setTimeout(() => {
			rpoints.covered.classList.remove('small');
		}, DURATION - 100);
	}

	_animate_year(_rendered_values.year, target_stats.year);
}

function _render(){
	rpoints.highway.classList.toggle('hidden',!state.roads);
	rpoints.population.classList.toggle('hidden',!state.cities);
	rpoints.members.classList.toggle('hidden',!state.ama_members);
	rpoints.covered.classList.toggle('hidden',!state.covered_km);
}

_transition();
_render();

const _container = document.getElementById('container');

els.forEach(el=>_container.appendChild(el));